import _ from "lodash";
import filter from "@/filter/filter.sub.js"
export default {
  name: "editEle",
  data() {
    return {
      year: "",
      code: "",
      name: "",
      class1: "",
      class2: "",
      cargo: 0
    }
  },
  methods: {
    async saveOK() {
      const lo = await this.$store.dispatch("productInsert/saveEditElement", {
        method: this.method,
        data: {
          year: this.year,
          code: this.code,
          name: this.name,
          class1: this.class1,
          class2: this.class2,
          cargo: this.cargo
        },
        uid: this.data.uid
      });
      this.$emit("save", lo);
    },
    openshow() {
      this.year = "";
      this.code = "";
      this.name = "";
      this.class1 = "";
      this.class2 = "";
      this.cargo = 0
    },
    savecheck(ok) {
        ok();
    }
  },
  computed: {
    showbox: {
      get() {
        return this.show
      },
      set(data) {
        this.$emit("update:show", data)
      }
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    method: {
      type: String,
      default: "insert"
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
